"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = exports.baseStyles = void 0;
Object.defineProperty(exports, "createStyled", {
  enumerable: true,
  get: function get() {
    return _createStyled2.createStyled;
  }
});
exports.tokenizeTheme = exports.theme = exports.styled = exports.keyframes = exports.globalCss = exports.getCssText = exports.css = void 0;
var _createStyled2 = require("./createStyled");
var _createThemeConfig = require("../theme/createThemeConfig");
var defaultTheme = (0, _createThemeConfig.createThemeConfig)('abyss');
var _createStyled = (0, _createStyled2.createStyled)(defaultTheme),
  styled = _createStyled.styled,
  globalCss = _createStyled.globalCss,
  baseStyles = _createStyled.baseStyles,
  css = _createStyled.css,
  theme = _createStyled.theme,
  tokenizeTheme = _createStyled.tokenizeTheme,
  keyframes = _createStyled.keyframes,
  getCssText = _createStyled.getCssText,
  config = _createStyled.config;
exports.config = config;
exports.getCssText = getCssText;
exports.keyframes = keyframes;
exports.tokenizeTheme = tokenizeTheme;
exports.theme = theme;
exports.css = css;
exports.baseStyles = baseStyles;
exports.globalCss = globalCss;
exports.styled = styled;